import { render, staticRenderFns } from "./Indicateds.vue?vue&type=template&id=12d70c39&scoped=true"
import script from "./Indicateds.vue?vue&type=script&lang=js"
export * from "./Indicateds.vue?vue&type=script&lang=js"
import style0 from "./Indicateds.vue?vue&type=style&index=0&id=12d70c39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d70c39",
  null
  
)

export default component.exports